module.exports = __webpack_public_path__ + "img/btn.d39975c0.png";